"use client";

import React, { useState } from "react";
import { SectionContentProps } from "../../types";
import LogoUploader from "../../sections/header/LogoUploader";
import { PiListBold, PiXBold } from "react-icons/pi";

export default function CollegeHeader({
  content,
  onContentChange,
  isSelected,
  defaultLogo,
}: SectionContentProps) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const fontFamily = content.fontFamily || "'Inter', sans-serif";

  const navItems = content.navItems || [
    { label: "About", sectionId: "about" },
    { label: "Programs", sectionId: "programs" },
    { label: "Admissions", sectionId: "admissions" },
    { label: "Campus", sectionId: "campus" },
    { label: "Contact", sectionId: "contact" }
  ];

  const handleLogoChange = (newLogoUrl: string) => {
    onContentChange?.({ ...content, logo: newLogoUrl });
  };

  const primaryBg = content.colorPalette?.primary || "#1E3A8A"; // Collegiate Navy Blue

  return (
    <header
      className={`w-full transition-all relative z-50 shadow-md ${isSelected ? "ring-2 ring-blue-500 z-50" : ""}`}
      style={{ fontFamily, backgroundColor: primaryBg }}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between py-4">
        {/* Logo */}
        <div className="flex items-center flex-shrink-0">
          <LogoUploader
            currentLogo={content.logo}
            defaultLogo={defaultLogo || "COLLEGE"}
            onLogoChange={handleLogoChange}
            heightClass="h-9"
            primaryColor="#FFFFFF"
            secondaryColor="#F59E0B"
            companyName={content.companyName || "COLLEGE"}
            isEditing={!!onContentChange}
          />
        </div>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-6">
          {navItems.map((item: any, idx: number) => {
            const navItem = typeof item === "string" ? { label: item, sectionId: item.toLowerCase() } : item;
            return (
              <a
                key={idx}
                href={`#${navItem.sectionId}`}
                className="text-sm font-semibold text-white/90 hover:text-amber-400 transition-colors"
              >
                {navItem.label}
              </a>
            );
          })}
        </nav>

        {/* CTA Button */}
        <div className="hidden md:block">
          <a
            href={content.ctaLink || "#apply"}
            className="px-5 py-2 rounded-lg bg-amber-500 hover:bg-amber-600 text-white font-bold text-sm transition-all shadow"
          >
            {content.ctaText || "Apply Now"}
          </a>
        </div>

        {/* Mobile menu button */}
        <div className="md:hidden">
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="text-white hover:text-amber-400 p-2"
          >
            {isMobileMenuOpen ? <PiXBold className="h-6 w-6" /> : <PiListBold className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-slate-900 border-t border-slate-800 py-4 px-6 space-y-4">
          {navItems.map((item: any, idx: number) => {
            const navItem = typeof item === "string" ? { label: item, sectionId: item.toLowerCase() } : item;
            return (
              <a
                key={idx}
                href={`#${navItem.sectionId}`}
                onClick={() => setIsMobileMenuOpen(false)}
                className="block text-sm font-semibold text-white/95 hover:text-amber-400 py-1"
              >
                {navItem.label}
              </a>
            );
          })}
          <a
            href={content.ctaLink || "#apply"}
            onClick={() => setIsMobileMenuOpen(false)}
            className="block text-center py-2.5 rounded-lg bg-amber-500 hover:bg-amber-600 text-white font-bold text-sm shadow"
          >
            {content.ctaText || "Apply Now"}
          </a>
        </div>
      )}
    </header>
  );
}
